//EDM: message array example:
// var $message_array = {'required': "<?php echo $this->translate("Please fill out all required fields!");?>",
//     'passwords': "<?php echo $this->translate("Passwords do not match");?>"};

$message_keys = [];
$fields_ok = true;

function TxValidationClear(form) {
    $fields_ok = true;
    $message_keys.splice(0);
    $(document.forms[form] || form).find('.has-error').removeClass('has-error');
}

function focusFirstError(form) {
    $(document.forms[form] || form).first().find('.has-error input:visible').first().focus();
}

function TxValidateEmail(element) {
    if (element.val() && !validateEmail(element.val())) {
        element.parent().addClass('has-error');
        $fields_ok = false;
        $message_keys.push('email');
    }
}

function TxValidateRequiredText(element) {

    if (!element.val()) {
        $fields_ok = false;
        element.parent().addClass('has-error');
        $message_keys.push('required');
    }
    // console.log('required text ' + element.val());
}

function TxValidateRequiredCheck(element) {

    if (!element.prop('checked')) {
        element.parents('.input-group').addClass('has-error');
        $fields_ok = false;
        $message_keys.push('required');
    }

}


function TxMatchPasswords(password_element, confirm_element) {

    TxValidateRequiredText(password_element);
    TxValidateRequiredText(confirm_element);

    if (password_element.val() != confirm_element.val()) {
        $fields_ok = false;
        password_element.parent().addClass('has-error');
        confirm_element.parent().addClass('has-error');

        $message_keys.push('passwords');
    }
}

function TxPasswordLength(password_element) {

    $min_length = (password_element.attr('minLength')) ? password_element.attr('minLength') : 10;
    $max_length = (password_element.attr('maxLength')) ? password_element.attr('maxLength') : 20;

    $pwLength = password_element.val().trim().length;

    if ($pwLength < $min_length || $pwLength > $max_length) {
        $fields_ok = false;
        password_element.parent().addClass('has-error');

        $message_keys.push('password_length');
    }

}

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

//functies van bart om 0 toe te voegen aan de tijd
function fixTime(pctl) {
    var t = pctl.value;
    var m = t.match(/^\s*(2[0-4](?![0-9]\s*$)|[0-1][0-9](?![0-9]\s*$)|[0-9])\s*[hu.:]?\s*([0-5]?[0-9])?\s*$/i);
    if (m) {
        if (m[1] == "24") m[1] = "00";
        if (m[1].length == 1) m[1] = "0" + m[1];
        if (!m[2]) m[2] = "00";
        if (m[2].length == 1) m[2] = "0" + m[2];
        pctl.value = m[1] + ":" + m[2];
        return true;
    }
    else if (t.match(/^\s*$/)) {
        pctl.value = "";
        return true;
    }
    return false;
}

function checkTime(pctl, validate) {
    var t = pctl.value;
    if (fixTime(pctl)) {
        pctl.style.backgroundColor = "white";
        return true;
    }
    else if (validate) {
        pctl.style.backgroundColor = "#ffffcc";
        pctl.focus();
        return false;
    }
    return true;
}

function time_OnChange(ctl, index) {
    checkTime(ctl, "1");

    return true;
}

function boolVal(b) {
    if(typeof b == 'number' || b === true || b === false)
        return !!b;
    if(typeof b == 'string') {
        switch(b) {
        case 'on':
        case 'yes':
        case 'true':
        case '1':
            return true;
        case 'off':
        case 'no':
        case 'false':
        case '0':
            return false;
        }
    }
    return; // undefined
}